import axios from "axios";

export const axiosAuthInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
